import * as types from "../constants/AppConstants";

export function toogleLoading() {
  return {
    type: types.TOOGLE_LOADING
  };
}

export const showAlert = notification => ({
  type: types.SHOW_ALERT,
  notification: {
    key: new Date().getTime() + Math.random(),
    ...notification
  }
});

export const removeAlert = key => ({
  type: types.HIDE_ALERT,
  key
});
